/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Templates_Move_FailedInputs */



/**
* | output |
* | --- |
* | "We could not save the new order. Try again in a moment." |
*
* @param {Settings_Templates_Move_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_templates_move_failed = /** @type {((inputs?: Settings_Templates_Move_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Templates_Move_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("We konden de nieuwe volgorde niet bewaren. Probeer het zo meteen opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous n'avons pas pu enregistrer le nouvel ordre. Réessayez dans un instant.")
	return /** @type {LocalizedString} */ ("We could not save the new order. Try again in a moment.")
});